import { useCallback, useRef, useState } from 'react';
import { css, cx } from '@emotion/css';
import style from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

type tab = {
    key: number;
    name: string;
    desc: string;
    link: string;
};

export default function Recommend() {
    const { useLang } = useGlobal();
    const { t } = useLang('landingPage');
    const [currentTab, setCurrentTab] = useState(2);
    const [boxHeightMap, setHeightMap] = useState([]);
    const heightTmpRef = useRef<any>([]);

    const tabs: tab[] = [
        {
            key: 0,
            name: t('recommend.Media0'),
            desc: t.rich('recommend.Quote0', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://www.theverge.com/2023/1/5/23536809/ecoflow-whole-home-backup-price-tax-credit-specs',
        },
        {
            key: 1,
            name: t('recommend.Media1'),
            desc: t.rich('recommend.Quote1', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://techcrunch.com/2023/01/05/ecoflow-launches-battery-backup-a-lawnmower-a-portable-a-c-and-a-portable-fridge/amp/',
        },
        {
            key: 2,
            name: t('recommend.Media2'),
            desc: t.rich('recommend.Quote2', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://www.benzinga.com/general/23/03/31494970/how-to-prepare-your-home-for-power-grid-brownouts-blackouts',
        },
        {
            key: 3,
            name: t('recommend.Media3'),
            desc: t.rich('recommend.Quote3', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://www.makeuseof.com/ecoflow-launches-whole-home-backup-power-solution/',
        },
        {
            key: 4,
            name: t('recommend.Media4'),
            desc: t.rich('recommend.Quote4', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://phandroid.com/2023/01/05/ecoflows-new-power-station-can-backup-your-entire-home/',
        },
    ];

    const measuredRef = useCallback((node: HTMLDivElement, index: number) => {
        if (!node || !heightTmpRef.current) return;

        heightTmpRef.current[index] = node.clientHeight;
        const size = heightTmpRef.current.filter((i: any) => i).length;
        if (size === 3) {
            setHeightMap(heightTmpRef.current);
            heightTmpRef.current = null;
        }
    }, []);

    const onClickTab = (e: any, key: number) => {
        setCurrentTab(key);
        e.preventDefault();
    };

    return (
        <div className={style.recommend}>
            <div className="viewport-wrapper">
                <div className="title">{t('recommend.title')}</div>
                <div className="tabs-bar">
                    <div className="tabs">
                        {tabs.map((tab: tab) => (
                            <div key={tab.key} className={`tab ${tab.key === currentTab ? 'select' : ''}`} onClick={(e) => onClickTab(e, tab.key)}>
                                {tab.name}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="content">
                    <div
                        className={cx(
                            'desc',
                            css`
                                max-height: ${boxHeightMap[currentTab] ? `${boxHeightMap[currentTab]}px` : '1000px'};
                            `,
                        )}
                    >
                        {tabs.map((item: tab, index: number) => (
                            <div
                                ref={(element: any) => measuredRef(element, index)}
                                className={`desc-text ${index === currentTab ? 'active' : 'leave'}`}
                                key={index}
                                onClick={() => window.open(item.link)}
                            >
                                {item.desc}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
